<div class="dropdown-wrapper">
    <ham-button
        #statusFilterButtonWrapper
        class="status-filter-button"
        size="lg"
        [variant]="selectedStatus?.length && isFilterActive ? 'transparent' : 'white'"
        [outline]="true"
        rightIcon="assets/hamIcons/chevron-down.svg"
        (click)="openFlyout(statusFilterButtonWrapper)"
    >
        <span class="filter-number" *ngIf="selectedStatus?.length && isFilterActive && !singleSelection">
            {{ selectedStatus?.length }}
        </span>
        {{ 'aumico_pm_tasks_status_filter_label' | i18next }}
    </ham-button>
</div>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-content">
        <div
            *ngFor="let status of statusOptions"
            class="custom-checkbox status-option"
            (click)="toggleStatusSelection(status.value)"
            [class.selected]="selectedStatus?.includes(status.value) && singleSelection"
        >
            <input
                *ngIf="!singleSelection"
                type="checkbox"
                [checked]="selectedStatus?.includes(status.value)"
                (change)="$event.stopPropagation()"
            />
            <label (click)="$event.stopPropagation(); toggleStatusSelection(status.value)">{{ status.label }}</label>
        </div>
        <div class="filter-actions">
            <ham-button *ngIf="!singleSelection" variant="teal" size="sm" (click)="applyFilter()">{{
                'aumico_pm_tasks_apply_filter' | i18next
            }}</ham-button>
            <ham-button variant="white" size="sm" (click)="clearFilter()">{{
                'aumico_pm_tasks_filter_clear' | i18next
            }}</ham-button>
        </div>
    </div>
</span>
